/* ASSETS  */
import boutonLire from "assets/img/bouton_lire.png";
import boutonLireHoover from "assets/img/bouton_lire_hoover.png";
import boutonRegarder from "assets/img/bouton_regarder.png";
import boutonRegarderHoover from "assets/img/bouton_regarder_hoover.png";
import boutonCoeur from "assets/img/bouton_coeur.png";
import boutonCoeurHoover from "assets/img/bouton_coeur_hoover.png";
import homeIconBlack from "assets/img/home-icon-black.png";

import blockBlancFakeChoiceSmall from "assets/img/bloc_blanc_fakechoice_small.png";
// import blockBlancFakeChoiceMedium from 'assets/img/bloc_blanc_fakechoice_medium.png';
import blockBlancFakeChoiceLarge from "assets/img/bloc_blanc_fakechoice_large.png";

/* FOREGROUND */
import portrait from "assets/img/journey/hassan/portrait.png";
// import tanks from 'assets/img/journey/hassan/tanks.png';
import tank_1 from "assets/img/journey/hassan/tank_1.png";
import tank_2 from "assets/img/journey/hassan/tank_2.png";
import tank_3 from "assets/img/journey/hassan/tank_3.png";
import tank_4 from "assets/img/journey/hassan/tank_4.png";
import phoneClear from "assets/img/journey/hassan/phoneClear.png";
import phoneFill from "assets/img/journey/hassan/phoneFill.png";
import phoneHalf from "assets/img/journey/hassan/phoneHalf.png";

import epilogue_silhouette from "assets/img/journey/hassan/epilogue_silhouette.png";

import sequenceShared1 from "assets/img/journey/hassan/sequenceShared1.png";
import sequenceShared2 from "assets/img/journey/hassan/sequenceShared2.png";
import sequenceShared3 from "assets/img/journey/hassan/sequenceShared3.png";
import sequenceShared4 from "assets/img/journey/hassan/sequenceShared4.png";

import sequenceNotShared1 from "assets/img/journey/hassan/sequenceNotShared1.png";
import sequenceNotShared2 from "assets/img/journey/hassan/sequenceNotShared2.png";
import sequenceNotShared3 from "assets/img/journey/hassan/sequenceNotShared3.png";

import famille from "assets/img/journey/hassan/famille.png";
import phoneWhatsapp from "assets/img/journey/hassan/phoneWhatsapp.png";

import PhylactereHassan from "assets/img/journey/hassan/phylactere_studeren.png";

/* BACKGROUND */
import baseBackgroundImg from "assets/img/home-background-min.jpg";
import backgoundPurple from "assets/img/backgound_purple.jpg";
import hassanBG1 from "assets/img/journey/hassan/DE3N2Y-min.jpg";
import hassanBG2 from "assets/img/journey/hassan/2CDN1JD-min.jpg";
import hassanBG7 from "assets/img/journey/hassan/2CBDBK5.jpg";
import hassanBG8 from "assets/img/journey/hassan/FWX4GM.jpeg";
import hassanBG9 from "assets/img/journey/hassan/2AB5JNR.jpg";
import hassanBG10 from "assets/img/journey/hassan/S3275H-min.jpg";
import hassanBG11 from "assets/img/journey/hassan/H60954.jpg";
import hassanBG12 from "assets/img/journey/hassan/TXNE40-min.jpeg";
import hassanBG13 from "assets/img/journey/hassan/PHY967-min.jpeg";
import hassanBG14 from "assets/img/journey/hassan/D2G5AR-min.jpeg";
import hassanBG15 from "assets/img/journey/hassan/F5687K-min.jpg";
import hassanBG16 from "assets/img/journey/hassan/hassan_service_des_etrangers.jpg";
import hassanBG18 from "assets/img/journey/hassan/parcours_3_lettre_ofice_etrangers-min.jpg";
import hassanBG19 from "assets/img/journey/hassan/2BK96PF-min.jpeg";
import hassanBG20 from "assets/img/journey/hassan/A4T8Y1-min.jpg";
import hassanBG21 from "assets/img/journey/hassan/shutterstock_266821754-min.jpg";
import hassanBG23 from "assets/img/journey/hassan/H9FA4A-min.jpeg";

/* MAPS */
import mapSyrieTurquie from "assets/img/journey/hassan/syrie_carte_1-min_NL.png";
import mapTurquieEurope from "assets/img/journey/hassan/NL_parcours_3_carte_2.png";

import mapIncoherence1 from "assets/img/journey/hassan/hassan_ecran_adieux_salim_NL.png";

/* sounds */
import soundIntro from "assets/sounds/hassan_nl/HASSAN_NL_INTRO.mp3";
import HASSAN_FR_SEQ01 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ01.mp3";
import HASSAN_FR_SEQ02 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ02.mp3";
import HASSAN_FR_SEQ03 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ03.mp3";
import HASSAN_FR_SEQ04 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ04.mp3";
import HASSAN_FR_SEQ05 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ05.mp3";
import HASSAN_FR_SEQ06 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ06.mp3";
import HASSAN_FR_SEQ07 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ07.mp3";
import HASSAN_FR_SEQ08 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ08.mp3";
import HASSAN_FR_SEQ09 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ09.mp3";
import HASSAN_FR_SEQ10 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ10.mp3";
import HASSAN_FR_SEQ11 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ11.mp3";
import HASSAN_FR_SEQ12 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ12.mp3";
import HASSAN_FR_SEQ13 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ13.mp3";
import HASSAN_FR_SEQ14 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ14.mp3";
import HASSAN_FR_SEQ15 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ15.mp3";
import HASSAN_FR_SEQ16 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ16.mp3";
import HASSAN_FR_SEQ17 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ17.mp3";
import HASSAN_FR_SEQ18 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ18.mp3";
import HASSAN_FR_SEQ19 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ19.mp3";
import HASSAN_FR_SEQ20 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ20.mp3";
import HASSAN_FR_SEQ21 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ21.mp3";
import HASSAN_FR_SEQ22 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ22.mp3";
import HASSAN_FR_SEQ23 from "assets/sounds/hassan_nl/HASSAN_NL_SEQ23.mp3";

import HASSAN_FR_EPILOG1 from "assets/sounds/hassan_nl/HASSAN_NL_EPILOG1.mp3";
import HASSAN_FR_EPILOG2 from "assets/sounds/hassan_nl/HASSAN_NL_EPILOG2.mp3";

import HASSAN_FR_EPILOGFIN1 from "assets/sounds/hassan_nl/HASSAN_NL_EPILOGFIN1.mp3";
import HASSAN_FR_EPILOGFIN2 from "assets/sounds/hassan_nl/HASSAN_NL_EPILOGFIN2.mp3";

import { getYoutubeIframe, colors } from "./utils";

// import HASSAN_FR_?? from 'assets/sounds/hassan_fr/HASSAN_FR_unkown.mp3';

// import blocNoir from 'assets/img/bloc_noir-min.png';
// import blocNoirHover from 'assets/img/block_noir_hoover-min.png';

const choiceButtonStyle = {
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: 20,
  padding: "30px!important",
  minHeight: 100,
  maxWidth: 250,
  color: "white",
};

const otherChoiceButtonStyle = {
  ...choiceButtonStyle,
  fontSize: "1.5rem!important",
  fontWeight: "700!important",
  color: "black!important",
  maxWidth: 200,
  backgroundImage: `url(${blockBlancFakeChoiceSmall})!important`,
  "&:hover": { textDecoration: "underline" },
};

const base_choice_style = {
  containerStyle: {
    backgroundColor: "white",
    color: "black",
  },
  fixedImageBackground: portrait,
  fixedImageBackgroundStyle: {
    backgroundSize: "35% auto",
    backgroundPosition: "95% center",
  },

  homeIcon: homeIconBlack,
  homeHoverIcon: homeIconBlack,

  contentStyle: {
    width: "50%",
    maxWidth: "1150px",
    marginLeft: "10%",
  },
};

const epilogeAnimationTiming = 2500;
const epilogeSoundAdditionalDelay = 1500;
const base_epilogue = {
  type: "epilogue",
  background: { src: backgoundPurple },
  foreground: {
    src: epilogue_silhouette,
    // style: { height: '80vh', position: 'relative', top: '10vh', left: '0vw', opacity: 1, transition: 'transform linear', transform: 'scale(1)' }, //, transformOrigin: '27.5% 65.1%'
    style: {
      height: "80vh",
      position: "relative",
      top: "10vh",
      left: "0vw",
      opacity: 0,
      animationFillMode: "forwards",
      animationTimingFunction: "linear",
      transform: "scale(.7) translateX(-30%)",
    }, //, transformOrigin: '27.5% 65.1%'
    animations: [{ delay: 250, style: { animationName: "opacityNoneToFull", animationDuration: `${epilogeAnimationTiming}ms` } }],
  },
};

export const hassan_nl = {
  description: {
    name: "Hassan",
    age: "17",
    city: "Latakia",
    country: "Syrië",
    text: "De stad waar ik woon, Latakia, is volgens mij de mooiste van Syrië. Ik woon er samen met mijn vader, moeder en zus. Ik heb ook een broer maar die heb ik al een tijdje niet meer gezien. Hij zit namelijk in het leger.  Als ik op mijn balkon sta zie ik de bergen en ruik ik de zee, dan droom ik over alles wat daarin leeft. Mijn droom is om bioloog te worden. Studeren zal ik in Damascus doen, de hoofdstad van Syrië. Mijn zus lacht me er vaak mee uit maar ik ben toch wel wat bang om zo ver van mijn familie en vrienden te zijn. Ik ga hen zo missen...",
    sound: soundIntro,
  },
  additionalLoad: [
    { type: "img", src: backgoundPurple },
    { type: "img", src: tank_1 },
    { type: "img", src: tank_2 },
    { type: "img", src: tank_3 },
    { type: "img", src: tank_4 },
    { type: "img", src: phoneClear },
    { type: "img", src: phoneFill },
    { type: "img", src: phoneHalf },
    { type: "img", src: portrait },
    { type: "img", src: sequenceShared1 },
    { type: "img", src: sequenceShared2 },
    { type: "img", src: sequenceShared3 },
    { type: "img", src: sequenceShared4 },
    { type: "img", src: sequenceNotShared1 },
    { type: "img", src: sequenceNotShared2 },
    { type: "img", src: sequenceNotShared3 },
    { type: "img", src: epilogue_silhouette },
    { type: "img", src: famille },
  ],
  steps: [
    {
      id: "HASSAN 01",
      type: "sequence",
      sound: HASSAN_FR_SEQ01,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Zomer 2011, Ik ben afgestudeerd! ", delay: 3040 },
        { type: "text", text: "Met mijn vrienden ga ik straks naar het park bij de moskee om te gaan vieren.", delay: 3060 },
        { type: "text", text: "Bijna de hele klas zal er zijn! ", delay: 3930 },
        { type: "text", text: "Al maanden praten we bijna non-stop met elkaar over onze toekomstplannen. ", delay: 1200 },
        { type: "text", text: "Veel van mijn klasgenoten zullen het leger ingaan.", delay: 4000 },
        { type: "text", text: "In Syri\u00eb is er namelijk een dienstplicht als je niet verder studeert. ", delay: 3820 },
        { type: "text", text: "Hoe hard ik ook heb uitgekeken naar vandaag, ik heb toch een dubbel gevoel. ", delay: 3960 },
        { type: "text", text: "Het is hier al een tijdje erg onrustig.", delay: 4180 },
        { type: "text", text: "In het hele land wordt er al maandenlang geprotesteerd tegen de regering. ", delay: 2950 },
        { type: "text", text: "Ik ben bang om mijn ouders en zus achter te laten wanneer ik naar Damascus vertrek.", delay: 4000 },
        { type: "text", text: "", delay: 5070 },
        { type: "goToNext", delay: 2840 },
      ],
      background: {
        src: hassanBG1,
        style: { width: "120vw", position: "relative", left: "-20vw" }, // transition: 'transform linear'
        animations: [
          { delay: 50, style: { animationDuration: "42000ms", animationName: "translateX0To20vw" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "HASSAN 02",
    },
    {
      id: "HASSAN 02",
      type: "sequence",
      sound: HASSAN_FR_SEQ02,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Aangekomen in het park zien we een groep betogers bij de moskee. ", delay: 2060 },
        { type: "text", text: "Ik wist dat er vandaag een demonstratie zou plaatsvinden. ", delay: 3990 },
        { type: "text", text: "Mijn oom had me zelfs nog gevraagd om mee te gaan. ", delay: 2980 },
        { type: "text", text: "Hij snapt niet waarom we niet allemaal de straat op gaan om te betogen. ", delay: 2100 },
        { type: "text", text: "Ook al heb ik veel respect voor hem, ik denk dat het veiliger is om dat niet te doen. ", delay: 3080 },
        { type: "text", text: "Ik wil mijn toekomst niet op het spel zetten. ", delay: 4830 },
        { type: "text", text: "Mensen houden spandoeken in de lucht en roepen om meer vrijheid en democratie", delay: 2170 },
        { type: "text", text: "", delay: 4850 },
        { type: "goToNext", delay: 2100 },
      ],
      background: {
        src: hassanBG2,
        style: {},
        animations: [{ delay: 50, style: { animationName: "scale20", animationDuration: "28110ms" } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "HASSAN 03",
    },
    {
      id: "HASSAN 03",
      type: "sequence",
      sound: HASSAN_FR_SEQ03,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Plots horen we tanks dichtbij komen. ", delay: 2080 },
        { type: "text", text: "Er stappen mensen uit en beginnen gewoon te schieten!", delay: 2090 },
        { type: "text", text: "Mensen gillen, beginnen te huilen, lopen weg. Dit is hallucinant! ", delay: 2930 },
        { type: "text", text: "Als bij reflex haal ik mijn gsm uit en begin ik alles te filmen.", delay: 5030 },
        { type: "text", text: "", delay: 4030 },
        { type: "goToNext", delay: 1080 },
      ],
      background: {
        src: baseBackgroundImg,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },
      foreground: {
        src: tank_1,
        style: { height: "30vh", opacity: 0, transform: "translate(calc((100vw - 75vh)/2) , -15vh)" },
        animations: [
          { delay: 3000, style: { animationName: "opacityNoneToFull", animationDuration: "500ms" } },
          { delay: 2500, style: { animationName: "opacityFullToNone", animationDuration: "500ms" } },
          {
            delay: 500,
            src: tank_2,
            style: {
              height: "40vh",
              transform: "translate(calc((100vw - (1.8 * 40vh))/2) , -5vh)",
              animationName: "opacityNoneToFull",
              animationDuration: "500ms",
            },
          },
          {
            delay: 3000,
            src: tank_2,
            style: {
              height: "40vh",
              transform: "translate(calc((100vw - (1.8 * 40vh))/2) , -5vh)",
              animationName: "opacityFullToNone",
              animationDuration: "500ms",
            },
          },
          {
            delay: 500,
            src: tank_3,
            style: { height: "40vh", transform: "translate(0 , 5vh)", animationName: "opacityNoneToFull", animationDuration: "500ms" },
          },
          {
            delay: 4500,
            src: tank_3,
            style: { height: "40vh", transform: "translate(0 , 5vh)", animationName: "opacityFullToNone", animationDuration: "500ms" },
          },
          {
            delay: 500,
            src: tank_4,
            style: {
              height: "40vh",
              transform: "translate(calc(-1*(100vw - (0 * 40vh))/2) , 10vh)",
              animationName: "opacityNoneToFull",
              animationDuration: "500ms",
            },
          },
          {
            delay: 3500,
            src: tank_4,
            style: {
              height: "40vh",
              transform: "translate(calc(-1*(100vw - (0 * 40vh))/2) , 10vh)",
              animationName: "opacityFullToNone",
              animationDuration: "500ms",
            },
          },
          // { delay: 50, style: { animationName: 'animationHassanTanks', animationDuration: '18110ms' } },
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "HASSAN 04",
    },
    {
      id: "HASSAN 04",
      type: "sequence",
      sound: HASSAN_FR_SEQ04,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Uiteindelijk loop ik naar huis en vertel alles aan mijn moeder. ", delay: 2070 },
        { type: "text", text: "Ook mijn oom is gelukkig op tijd kunnen weg geraken", delay: 3140 },
        { type: "text", text: "en is naar ons huis gekomen waar ik hem huilend aantref. ", delay: 2790 },
        { type: "text", text: "Ze hebben zijn zoon, mijn neef, neergeschoten.", delay: 3020 },
        { type: "text", text: "Ik ben razend! ", delay: 3110 },
        { type: "text", text: "Mijn neef deed helemaal niets verkeerd! ", delay: 1990 },
        { type: "text", text: "Mijn oom wil dit aanklagen en smeekt daarom dat ik het filmpje dat ik maakte ", delay: 2040 },
        { type: "text", text: "op mijn facebookpagina deel. ", delay: 3060 },
        { type: "text", text: "Hoe boos ik ook ben, ik twijfel. ", delay: 1980 },
        { type: "text", text: "", delay: 2900 },
        { type: "goToNext", delay: 1910 },
      ],
      background: {
        src: baseBackgroundImg,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },

      foreground: {
        src: phoneFill,
        style: { height: "80vh", opacity: 0, marginBottom: "auto" },
        animations: [
          { delay: 2020, style: { animationName: "hassanPhoneAnimation1 ", animationDuration: "9150ms" } },
          { delay: 12150, src: phoneHalf, style: { height: "80vh", opacity: 1, marginBottom: "auto" } },
          {
            delay: 7070,
            src: phoneClear,
            style: { height: "80vh", opacity: 1, marginBottom: "auto", animationName: "hassanPhoneAnimation2 ", animationDuration: "70000ms" },
          },
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "info1",
    },
    {
      id: "choice1",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Wat zou jij doen in mijn plaats?<br/>Dit grote <span class="background-underlined medium">onrecht</span> aanklagen en de video delen op sociale media of op veilig spelen en <span class="background-underlined large">niets doen</span>?',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "De video delen ",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "HASSAN 05",
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Ja, ik ben<br/>er zeker van',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 05',
          //     },
          //     {
          //       text: 'Ik neem een<br/>andere beslissing',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
        {
          type: "button",
          key: "button-2",
          text: "De video niet delen ",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "HASSAN 06",
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Ja, ik ben<br/>er zeker van',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 06',
          //     },
          //     {
          //       text: 'Ik neem een<br/>andere beslissing',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
      ],
    },
    //5
    {
      id: "HASSAN 05",
      type: "sequence",
      sound: HASSAN_FR_SEQ05,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Mijn moeder is razend als ze hoort wat ik heb gedaan. ", delay: 1110 },
        { type: "text", text: "Niet veel later krijg ik een bericht van een nummer dat ik niet ken: ", delay: 2940 },
        { type: "text", text: "\u201cAls je niet snel verdwijnt dan doen wij je verdwijnen\u201d.", delay: 3040 },
        { type: "text", text: "Ik ben doodsbang. Wie is dit? Ik moet hier weg! Maar waarheen? ", delay: 3020 },
        { type: "text", text: "Turkije is niet zo ver en daar kan ik makkelijk heen.", delay: 5090 },
        { type: "text", text: "Ik kan ook naar het zuiden, naar Tartous gaan waar mijn neef Hamid woont", delay: 3820 },
        { type: "text", text: "Het is daar vrij rustig en als ik me wat op de achtergrond houd, ", delay: 5050 },
        { type: "text", text: "kan ik daar misschien in veiligheid blijven totdat alles hier weer op zijn plooien is gevallen.", delay: 2970 },
        { type: "text", text: "", delay: 4060 },
        { type: "goToNext", delay: 1920 },
      ],
      background: {
        src: baseBackgroundImg,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },

      foreground: {
        src: sequenceShared1,
        style: { height: "80vh", opacity: 0 },
        animations: [
          { delay: 50, style: { animationName: "opacityNoneToFull", animationDuration: "1690ms" } },
          { delay: 1690, style: { animationName: "opacityFullToNone", animationDuration: "1390ms" } },
          { delay: 1390, src: sequenceShared2, style: { animationName: "opacityNoneToFull", animationDuration: "1990ms" } },
          { delay: 1990, src: sequenceShared2, style: { animationName: "opacityFullToNone", animationDuration: "1990ms" } },
          { delay: 1990, src: sequenceShared3, style: { animationName: "opacityNoneToFull", animationDuration: "2780ms" } },
          { delay: 3990, src: sequenceShared3, style: { animationName: "opacityFullToNone", animationDuration: "1780ms" } },
          { delay: 1780, src: sequenceShared4, style: { height: "40vh", animationName: "animationHassanSent4", animationDuration: "13780ms" } },
          // src: sequenceShared2,
          // { delay: 50, style: { animationName: 'animationHassanSent1', animationDuration: '3690ms' } },
          // { delay: 3690, src: sequenceShared2, style:{ animationName: 'animationHassanSent2', animationDuration: '3990ms' } },
          // { delay: 3990, src: sequenceShared3, style:{ animationName: 'animationHassanSent3', animationDuration: '5780ms' } },
          // { delay: 6080, src: sequenceShared4, style:{height: '40vh', animationName: 'animationHassanSent4', animationDuration: '13780ms' }},
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "info2",
    },
    {
      id: "choice2",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Ik twijfel, wat zou jij doen?<br/>Zou je in <span class="background-underlined large">Syrië blijv</span>en en onderduiken bij je neef? Of op zeker spelen en meteen naar <span class="background-underlined large">Turkije vluchten</span>?',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Onderduiken bij neef in Tartoes",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "HASSAN 08",
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Ja, ik ben<br/>er zeker van',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 08',
          //     },
          //     {
          //       text: 'Ik neem een<br/>andere beslissing',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
        {
          type: "button",
          key: "button-2",
          text: "Wegvluchten naar Turkije ",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "mapTurquie",
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Ja, ik ben<br/>er zeker van',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'mapTurquie',
          //     },
          //     {
          //       text: 'Ik neem een<br/>andere beslissing',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
      ],
    },
    {
      id: "mapTurquie",
      type: "map",
      background: baseBackgroundImg,
      mapImage: mapSyrieTurquie,
      mapContainerClass: "cursor-gray",
      nextStepDelay: 3500,
      nextStepId: "HASSAN 10",
    },
    {
      id: "HASSAN 06",
      type: "sequence",
      sound: HASSAN_FR_SEQ06,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik besluit het filmpje niet te delen en verwijder het maar voor de zekerheid.", delay: 1050 },
        { type: "text", text: "Ik voel me er slecht bij. Mijn oom is eerst kwaad maar begrijpt het uiteindelijk wel.", delay: 3180 },
        { type: "text", text: "Zijn verdriet voor het verlies van zijn zoon is enorm, het mijne ook. ", delay: 5820 },
        { type: "text", text: "De situatie wordt alsmaar slechter ik hoop maar dat dit snel voorbij gaat.", delay: 4070 },
        { type: "text", text: "", delay: 4970 },
        { type: "goToNext", delay: 980 },
      ],
      background: {
        src: baseBackgroundImg,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },
      foreground: {
        src: sequenceNotShared1,
        style: { height: "80vh", opacity: 0 },
        animations: [
          { delay: 50, style: { animationName: "opacityNoneToFull", animationDuration: "1000ms" } },
          { delay: 4080, style: { animationName: "opacityFullToNone", animationDuration: "500ms" } },
          // { delay: 500, src: sequenceNotShared2, style:{ animationName: 'opacityNoneToFull', animationDuration: '1000ms' } },
          // { delay: 9190, style: { animationName: 'opacityFullToNone', animationDuration: '500ms' } },
          { delay: 500, src: sequenceNotShared3, style: { animationName: "opacityNoneToFull", animationDuration: "1000ms" } },
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "HASSAN 07",
    },
    {
      id: "HASSAN 07",
      type: "sequence",
      sound: HASSAN_FR_SEQ07,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ondertussen bevinden we ons in een staat van oorlog. ", delay: 1220 },
        { type: "text", text: "Waar ik woon is het gelukkig redelijk rustig. ", delay: 3790 },
        { type: "text", text: "Studeren in Damascus vonden mijn ouders toch net iets te riskant dus ben ik in Latakia gebleven. ", delay: 3050 },
        {
          type: "text",
          text: "Op een dag krijg ik een brief met de boodschap dat ik me moet melden bij het leger voor mijn dienstplicht. ",
          delay: 5950,
        },
        { type: "text", text: "Mijn broer heeft zich 2 jaar geleden gemeld. ", delay: 5020 },
        { type: "text", text: "We hebben al meer dan 6 maanden niets meer van hem gehoord", delay: 2190 },
        { type: "text", text: "en weten niet eens of hij nog leeft. ", delay: 2960 },
        { type: "text", text: "Ik wil echt niet in het leger. ", delay: 2040 },
        { type: "text", text: "Ik wil niet moeten vechten tegen mensen die mijn vrienden zijn. ", delay: 2780 },
        { type: "text", text: "De enige andere optie is vluchten. ", delay: 3020 },
        { type: "text", text: "Dat betekent mijn ouders, nonkel, vrienden maar ook mijn toekomstbeeld verlaten, ", delay: 2120 },
        { type: "text", text: "voor wie weet hoe lang. ", delay: 5920 },
        { type: "text", text: "Ik heb het gevoel dat ik moet kiezen tussen de pest en de cholera. ", delay: 2020 },
        { type: "text", text: "", delay: 3100 },
        { type: "goToNext", delay: 2000 },
      ],
      background: {
        src: hassanBG7,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "47130ms", animationName: "scale40" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "info4",
    },
    //10
    {
      id: "choice4",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Wat een onmogelijk dilemma! Wat zou jij doen in mijn plaats?<br/>Zou je je aanslu<span class="background-underlined very-large">iten bij het regerin</span>gsleger of alles en iedereen achterlaten en vluc<span class="background-underlined large">hten naar Turki</span>je?',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Vluchten uit Syrië",
          buttonStyle: choiceButtonStyle,
          action: "showConfirmation",
          confirmationContent: {
            title: 'Ben je zeker?<br/>Ik ga mijn fam<span class="background-underlined large">ilie zo miss</span>en',
            buttons: [
              {
                text: "Ja, ik ben<br/>er zeker van",
                buttonStyle: choiceButtonStyle,
                action: "goNext",
                nextStepId: "mapTurquie",
              },
              {
                text: "Ik neem een<br/>andere beslissing",
                buttonStyle: choiceButtonStyle,
                action: "closeConfirmation",
              },
            ],
          },
        },
        {
          type: "button",
          key: "button-2",
          text: "Bij het leger gaan ",
          buttonStyle: choiceButtonStyle,
          action: "showConfirmation",
          confirmationContent: {
            title: 'Ben je zeker?<br/>Ik wil geen <span class="background-underlined large">onschuldige mensen</span> moeten doden',
            buttons: [
              {
                text: "Ja, ik ben<br/>er zeker van",
                buttonStyle: choiceButtonStyle,
                action: "goNext",
                nextStepId: "HASSAN 09",
              },
              {
                text: "Ik neem een<br/>andere beslissing",
                buttonStyle: choiceButtonStyle,
                action: "closeConfirmation",
              },
            ],
          },
        },
      ],
    },
    {
      id: "HASSAN 08",
      type: "sequence",
      sound: HASSAN_FR_SEQ08,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik ben bij mijn neef Hamid. ", delay: 2070 },
        { type: "text", text: "Het deed goed om elkaar terug te zien en ondanks de zorgen voelde ik me relatief veilig. ", delay: 2000 },
        { type: "text", text: "Ondertussen is de oorlog hier uitgebarsten. ", delay: 6010 },
        { type: "text", text: "Dit had ik echt nooit kunnen denken. Studeren zit er nu even niet in. ", delay: 3030 },
        { type: "text", text: "Ik moet me daarom melden bij het leger voor mijn dienstplicht, maar dat wil ik niet. ", delay: 4130 },
        { type: "text", text: "Mijn broer heeft zich twee jaar geleden gemeld. ", delay: 4880 },
        { type: "text", text: "We hebben al 6 maanden niets meer van hem gehoord. ", delay: 2090 },
        { type: "text", text: "Ik weet niet eens of hij nog leeft.", delay: 2960 },
        { type: "text", text: "Als ik in het leger ga, zal ik mensen moeten doden. ", delay: 3020 },
        { type: "text", text: "Mensen die mijn vrienden zouden kunnen zijn. ", delay: 3010 },
        { type: "text", text: "Als ik me niet aanmeld, kan ik ieder moment worden gearresteerd. ", delay: 2960 },
        { type: "text", text: "Elke keer dat ik me op straat begeef zal ik doodsangsten uitstaan. ", delay: 3860 },
        { type: "text", text: "Erger nog, ik breng Hamid en mijn oom en tante in gevaar door me niet aan te melden. ", delay: 3990 },
        { type: "text", text: "De enige andere optie is vluchten uit Syri\u00eb. ", delay: 5080 },
        { type: "text", text: "Weg van mijn ouders, zus, vrienden. Weg van mijn dromen en toekomst. ", delay: 2960 },
        { type: "text", text: "Wat een onmogelijk dilemma.", delay: 5080 },
        { type: "text", text: "", delay: 2100 },
        { type: "goToNext", delay: 1990 },
      ],
      background: {
        src: hassanBG8,
        style: {},
        animations: [{ delay: 50, style: { animationName: "scale30", animationDuration: "61220ms" } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "info3",
    },
    {
      id: "choice3",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Wat een onmogelijk dilemma! Wat zou jij doen in mijn plaats?<br/>Zou je je aanslu<span class="background-underlined very-large">iten bij het regerin</span>gsleger of alles en iedereen achterlaten en vluc<span class="background-underlined large">hten naar Turki</span>je?',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Vluchten uit Syrië",
          buttonStyle: choiceButtonStyle,
          action: "showConfirmation",
          confirmationContent: {
            title: 'Ben je zeker?<br/>Ik ga mijn fam<span class="background-underlined large">ilie zo miss</span>n',
            buttons: [
              {
                text: "Ja, ik ben<br/>er zeker van",
                buttonStyle: choiceButtonStyle,
                action: "goNext",
                nextStepId: "mapTurquie",
              },
              {
                text: "Ik neem een<br/>andere beslissing",
                buttonStyle: choiceButtonStyle,
                action: "closeConfirmation",
              },
            ],
          },
        },
        {
          type: "button",
          key: "button-2",
          text: "Bij het leger gaan ",
          buttonStyle: choiceButtonStyle,
          action: "showConfirmation",
          confirmationContent: {
            title: 'Ben je zeker?<br/>Ik wil geen o<span class="background-underlined large">nschuldige mensen</span> moeten doden',
            buttons: [
              {
                text: "Ja, ik ben<br/>er zeker van",
                buttonStyle: choiceButtonStyle,
                action: "goNext",
                nextStepId: "HASSAN 09",
              },
              {
                text: "Ik neem een<br/>andere beslissing",
                buttonStyle: choiceButtonStyle,
                action: "closeConfirmation",
              },
            ],
          },
        },
      ],
    },
    {
      id: "HASSAN 09",
      type: "sequence",
      sound: HASSAN_FR_SEQ09,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik heb me aangemeld bij het regeringsleger. ", delay: 3050 },
        { type: "text", text: "Dit is niet hoe ik me mijn toekomst had voorgesteld. Ik word hier slecht behandeld. ", delay: 2130 },
        { type: "text", text: "Mijn overste had al snel door welk vlees hij in de kuip had met mij. ", delay: 4840 },
        { type: "text", text: "Iemand die niet gemaakt is om te vechten.", delay: 3150 },
        { type: "text", text: "Hij kan het niet laten om me continu te pesten en te vernederen bij de anderen.", delay: 2870 },
        { type: "text", text: "Maar dat is nog het minste van mijn zorgen. ", delay: 3980 },
        { type: "text", text: "Continu ben ik bang om te moeten vechten en mensen te moeten doden die mijn vijanden niet zijn.", delay: 2110 },
        { type: "text", text: "In deze oorlog is het niet duidelijk meer wie de vijanden zijn ", delay: 4920 },
        { type: "text", text: "ik heb al verhalen gehoord van andere soldaten die vrienden moesten neerschieten. ", delay: 3970 },
        { type: "text", text: "Ik heb het gevoel dat ik niemand kan vertrouwen. ", delay: 4090 },
        { type: "text", text: "Ik mag me absoluut niet kritisch uitspreken over de president want dat kan me mijn kop kosten. ", delay: 2940 },
        { type: "text", text: "Maar als soldaat van het Syrische leger word ik ook door velen gehaat. ", delay: 4990 },
        { type: "text", text: "Mijn land is totaal gebroken.", delay: 3150 },
        { type: "text", text: "Ook ik ben totaal gebroken. ", delay: 3820 },
        { type: "text", text: "", delay: 3210 },
        { type: "goToNext", delay: 2830 },
      ],
      background: {
        src: hassanBG9,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "56050ms", animationName: "scale20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "epilogue_armee",
    },
    {
      id: "epilogue_armee",

      ...base_epilogue,

      sound: HASSAN_FR_EPILOG1,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          text: "Op een dag moeten we vechten in Homs, waar er al sinds lange tijd hevige gevechten woeden tussen de rebellengroepen en het regeringsleger. Ik hou me zo gedeisd mogelijk en probeer niet te schieten. Ik heb een slecht voorgevoel. Opeens hoor ik een verschrikkelijk geluid, daarna een knal. Ik val op de grond, ik hoor niets meer. Alles. Wordt. Zwart.",
          textStyle: { left: "45vw" },
        },
      ],
      nextStepId: "other_choices",
    },
    //15
    {
      id: "other_choices",
      type: "choice",

      ...base_choice_style,

      fixedImageBackground: baseBackgroundImg,

      fixedImageBackgroundStyle: {
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        zIndex: 0,
      },

      contentStyle: {
        width: "100%",
        maxWidth: "500px",
        marginLeft: "auto",
        marginRight: "auto",
        color: "white",
        zIndex: 100,
      },
      contentTextStyle: {
        textTransform: "none",
        textAlign: "center",
      },
      contentText:
        'Wil je weten wat er zou gebeurd zijn mocht je <span class="background-underlined large white">andere keuzes</span> hebben gemaakt?',

      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Ja, ik ga terug naar het begin van het parcours.",
          buttonStyle: otherChoiceButtonStyle,
          action: "goNext",
          nextStepId: "HASSAN 01",
        },
        {
          type: "button",
          key: "button-2",
          text: "Nee",
          buttonStyle: otherChoiceButtonStyle,
          action: "goNext",
          nextStepId: "-1",
        },
      ],
    },
    {
      id: "HASSAN 10",
      type: "sequence",
      sound: HASSAN_FR_SEQ10,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Vertrekken uit Syri\u00eb heeft mijn hart verscheurd. ", delay: 2020 },
        { type: "text", text: "Dit is het moeilijkste wat ik ooit heb moeten doen. ", delay: 3080 },
        { type: "text", text: "Weggaan uit je land, weg van je familie, vrienden ", delay: 3020 },
        { type: "text", text: "en alles wat je kent zonder zeker te zijn ooit nog terug te komen. ", delay: 3120 },
        { type: "text", text: "Ik wens het niemand toe. ", delay: 4920 },
        { type: "text", text: "Ondertussen ben ik in Mersin, een havenstadje in Turkije. Waar de beste vriend van mijn vader woont. ", delay: 1970 },
        { type: "text", text: "Mijn vader heeft iemand betaald om me over de grens te krijgen. Eerst met de bus, dan met de auto.", delay: 6080 },
        { type: "text", text: "Ik was doodsbang toen we militairen passeerden aan de grens, maar ze lieten ons gewoon door.", delay: 6880 },
        { type: "text", text: "Ik vraag me af hoeveel geld mijn vader hiervoor heeft moeten geven.", delay: 5980 },
        { type: "text", text: "Er zijn hier veel Syrische vluchtelingen, maar we krijgen hier weinig kansen.", delay: 3940 },
        { type: "text", text: "Hier en daar lukt het om een klusje te doen en wat geld te verdienen. ", delay: 4070 },
        { type: "text", text: "Ondertussen leerde ik een jongen kennen van mijn streek, Salim.", delay: 4000 },
        { type: "text", text: "Hij lijkt wel mijn soulmate te zijn.", delay: 4080 },
        { type: "text", text: "We zijn constant samen en helpen elkaar waar we kunnen.", delay: 2840 },
        { type: "text", text: "", delay: 3090 },
        { type: "goToNext", delay: 1110 },
      ],
      background: {
        src: hassanBG10,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "60200ms", animationName: "scaleDown20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "HASSAN 11",
    },
    {
      id: "HASSAN 11",
      type: "sequence",
      sound: HASSAN_FR_SEQ11,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Op een dag praten we over onze toekomst. ", delay: 4000 },
        { type: "text", text: "Allebei zien we het somber in. ", delay: 2080 },
        { type: "text", text: "Salim heeft ook dromen. ", delay: 1930 },
        { type: "text", text: "Hij was altijd een fervente gamer en wil daarom IT'er worden. ", delay: 1200 },
        { type: "text", text: "We weten allebei dat dat niet zal lukken in Turkije. ", delay: 3920 },
        { type: "text", text: "Hij zegt dat hij naar Europa wil, Belgi\u00eb meer bepaald want daar woont zijn broer. ", delay: 2960 },
        { type: "text", text: "HIj vraagt me om mee te gaan. ", delay: 5070 },
        { type: "text", text: "Het idee om hier alleen achter te blijven is niet bepaald aantrekkelijk, ", delay: 1920 },
        {
          type: "text",
          text: "maar de tocht naar Europa is ontzettend gevaarlijk. Bovendien is zo'n tocht duur en heb ik amper geld. ",
          delay: 3930,
        },
        { type: "text", text: "Ik wil absoluut geen geld aan mijn ouders vragen. ", delay: 6070 },
        { type: "text", text: "Zij zitten nog steeds in Syri\u00eb en maken zich al zoveel zorgen ", delay: 2970 },
        { type: "text", text: "dat ze de angst om mij te verliezen op weg naar Europa niet zouden overleven.", delay: 2140 },
        { type: "text", text: "Als ik zou meegaan met Salim zou dat al het geld kosten dat ik heb.", delay: 4890 },
        { type: "text", text: "", delay: 4030 },
        { type: "goToNext", delay: 3020 },
      ],
      background: {
        src: hassanBG11,
        style: {},
        animations: [{ delay: 50, style: { animationDuration: "50080ms", animationName: "scale20" } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "infoEurope",
    },
    {
      id: "choiceEurope",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Ik weet echt niet wat de beste keuze is. Wat zou jij doen mocht je in mijn schoenen staan?<br/>Zou je je leven riskeren en meega<span class="background-underlined very-large">an naar Europa</span>? Of zou je all<span class="background-underlined large">een in Turkije</span> blijven en hopen dat je hier toch een waardig leven kan opbouwen? ',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "In Turkije blijven",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "mapIncoherence1",
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Ja, ik ben<br/>er zeker van',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 14',
          //     },
          //     {
          //       text: 'Ik neem een<br/>andere beslissing',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
        {
          type: "button",
          key: "button-2",
          text: "Meegaan met Salim",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "mapEurope",
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Ja, ik ben<br/>er zeker van',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'mapEurope',
          //     },
          //     {
          //       text: 'Ik neem een<br/>andere beslissing',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
      ],
    },
    {
      id: "mapEurope",
      type: "map",
      background: baseBackgroundImg,
      mapImage: mapTurquieEurope,
      mapContainerClass: "cursor-gray",
      nextStepDelay: 3500,
      nextStepId: "HASSAN 12",
    },
    //20
    {
      id: "HASSAN 12",
      type: "sequence",
      sound: HASSAN_FR_SEQ12,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Zonder Salim zou ik dit niet durven maar we zijn zo close geworden de voorbije maanden ", delay: 3100 },
        { type: "text", text: "dat hij bijna aanvoelt als een broer voor mij.", delay: 4130 },
        { type: "text", text: "Met het weinige geld dat we hadden, hebben we een smokkelaar gevonden ", delay: 2990 },
        { type: "text", text: "die ons helpt om in Griekenland te geraken en nadien verder in Europa. ", delay: 3010 },
        { type: "text", text: "Het was moeilijk om de beste route te bepalen ", delay: 4860 },
        { type: "text", text: "want alsmaar meer grenzen naar Europa gaan op slot, om mensen zoals ons tegen te houden. ", delay: 2130 },
        { type: "text", text: "We varen nu met een bootje over de wilde Evros rivier om verder in Griekenland te geraken. ", delay: 5970 },
        { type: "text", text: "Het water is ijskoud en lijkt alsmaar wilder te worden. ", delay: 5030 },
        { type: "text", text: "We zitten met zeker 50 anderen in een boot die volgens mij voor max. 20 mensen is bedoeld. ", delay: 3980 },
        { type: "text", text: "Er is enorm veel wind en het regent zo hard dat we bijna niets voor ogen zien. ", delay: 5820 },
        { type: "text", text: "We krijgen ons bootje niet onder controle. ", delay: 5000 },
        { type: "text", text: "Ik zie Salim wild om zich heen slaan. ", delay: 2150 },
        { type: "text", text: "Hij is in paniek. Ik roep naar hem dat hij kalm moet blijven maar hij hoort me niet. ", delay: 2070 },
        { type: "text", text: "Ik schreeuw zijn naam maar kan hem niet meer zien. ", delay: 4920 },
        { type: "text", text: "Ik besef nu pas dat hij geen zwemvest aan heeft.", delay: 3040 },
        { type: "text", text: "", delay: 2800 },
        { type: "goToNext", delay: 1070 },
      ],
      background: {
        src: hassanBG12,
        style: {},
        animations: [{ delay: 50, style: { animationDuration: "61070ms", animationName: "scaleDown20" } }],
      },
      backgroundEffect: {
        style: { opacity: 0, backgroundColor: "black" }, //transition: 'opacity linear'
        animations: [{ delay: 40000, style: { animationName: "opacityNoneToFull", animationDuration: "20000ms" } }], //opacity: 1
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "HASSAN 13",
    },
    {
      id: "HASSAN 13",
      type: "sequence",
      sound: HASSAN_FR_SEQ13,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik ben terug in Turkije. ", delay: 4000 },
        { type: "text", text: "Zonder Salim, zonder geld, zonder perspectief. ", delay: 2020 },
        { type: "text", text: "Salim is in het water gevallen en waarschijnlijk verdronken.", delay: 4110 },
        { type: "text", text: "Ik herinner me hoe koud ik het had toen ik wakker werd aan de oever van de rivier. ", delay: 4890 },
        { type: "text", text: "Ik hoorde geroep en geblaf van honden en voelde mensen op me schoppen. ", delay: 3220 },
        { type: "text", text: "Samen met anderen die op mijn bootje zaten zijn we Griekenland uitgezet. ", delay: 4830 },
        { type: "text", text: "Zomaar. ", delay: 3160 },
        { type: "text", text: "Gewoon, het land uitgezet alsof we vuilnis zijn. ", delay: 1790 },
        { type: "text", text: "Alles is voor niets geweest", delay: 3160 },
        { type: "text", text: "Mijn beste vriend heeft zijn leven gegeven, voor niets.", delay: 2920 },
        { type: "text", text: "", delay: 4980 },
        { type: "goToNext", delay: 2010 },
      ],
      background: {
        src: hassanBG13,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "41000ms", animationName: "scale20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "choiceEuropeReessayer",
    },
    {
      id: "choiceEuropeReessayer",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Hoe moet ik nu verder?<br/>Zou je <span class="background-underlined large">opnieuw proberen</span> naar Europa te gaan of zou je in <span class="background-underlined large">Turkije blijven</span>?',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Opnieuw proberen",
          buttonStyle: choiceButtonStyle,
          action: "fakeChoice",
          actionText: "Ik ben kapot ik kan niet meer. Ik heb rust nodig. Bovendien ben ik blut.",
          actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceSmall})`, maxHeight: "60vh", width: "30vw", maxWidth: "400px" },
        },
        {
          type: "button",
          key: "button-2",
          text: "In Turkije blijven ",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "HASSAN 14",
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Ja, ik ben<br/>er zeker van',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 14',
          //     },
          //     {
          //       text: 'Ik neem een<br/>andere beslissing',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
      ],
    },
    {
      id: "HASSAN 14",
      type: "sequence",
      sound: HASSAN_FR_SEQ14,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik vind uiteindelijk een job in een textielfabriek dichtbij Istanbul.", delay: 4020 },
        { type: "text", text: "Ik werk 60 uur per week maar mijn loon is zo laag ", delay: 4000 },
        { type: "text", text: "dat ik toch nog af en toe naar de voedselbedeling moet aan de moskee. ", delay: 3080 },
        { type: "text", text: "Ik overleef. ", delay: 4020 },
        { type: "text", text: "Het is beter dan leven in oorlog, maar een leven kan je het eigenlijk amper noemen. ", delay: 1970 },
        { type: "text", text: "Ik woon in een kamer in een kelderappartement, samen met nog 10 andere Syri\u00ebrs.", delay: 5950 },
        { type: "text", text: "'s nachts slaap ik amper want ik krijg mijn hoofd maar niet stil. ", delay: 5100 },
        { type: "text", text: "Beelden van wat er gebeurd is flitsen continu door mijn hoofd. ", delay: 4910 },
        { type: "text", text: "Schuldgevoel ook. Heb ik wel de juiste keuzes gemaakt? ", delay: 4010 },
        { type: "text", text: "Ik maak me grote zorgen om mijn ouders en zus. ", delay: 4980 },
        { type: "text", text: "Zij wonen nog steeds in Syri\u00eb", delay: 2150 },
        { type: "text", text: "We hebben vaak contact maar van zodra ze even niet antwoorden, vrees ik meteen het ergste.", delay: 2820 },
        { type: "text", text: "Ondertussen heb ik ook het trieste nieuws gekregen dat mijn oom in Syri\u00eb gestorven is. ", delay: 5160 },
        { type: "text", text: "Mijn vader wilt dat ik een klein deel van de erfenis krijg.", delay: 5070 },
        { type: "text", text: "Daarmee zou ik mijn leven in Turkije iets kunnen verbeteren ", delay: 2990 },
        { type: "text", text: "ofwel toch een poging wagen om naar Europa te gaan, via de Griekse eilanden. ", delay: 3800 },
        { type: "text", text: "", delay: 5120 },
        { type: "goToNext", delay: 2010 },
      ],
      background: {
        src: hassanBG14,
        style: {},
        animations: [{ delay: 50, style: { animationDuration: "71160ms", animationName: "scale20" } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "infoResterFinalementTurquie",
    },
    {
      id: "choiceResterFinalementTurquie",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Ik weet het even niet meer. Wat zou jij doen mocht je mij zijn?<br/>Zou je in <span class="background-underlined very-large">Turkije blijven en p</span>roberen hier gelukkig te worden? Of zou je toch prob<span class="background-underlined large">eren naar Europa</span> te gaan?',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Naar Europa proberen gaan via de Griekse eilanden ",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "HASSAN 15",
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Ja, ik ben<br/>er zeker van',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 15',
          //     },
          //     {
          //       text: 'Ik neem een<br/>andere beslissing',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
        {
          type: "button",
          key: "button-2",
          text: "Een leven opbouwen in Turkije",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "epilogeEnTurqie",
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Ja, ik ben<br/>er zeker van',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'epilogeEnTurqie',
          //     },
          //     {
          //       text: 'Ik neem een<br/>andere beslissing',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
      ],
    },
    //25
    {
      id: "epilogeEnTurqie",

      ...base_epilogue,

      sound: HASSAN_FR_EPILOG2,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: "Dit is hoe mijn leven eruitziet in Turkije",
          text: "Mijn droom om te studeren voor bioloog heb ik opgeborgen maar ik woon nu tenminste wel in een studio die groot genoeg is. Ik vind werk dat iets beter betaald wordt en doe soms vrijwilligerswerk bij een ngo als vertaler. Ik spreek intussen een aardig mondje Turks. Het leven is niet fantastisch maar ik leef tenminste nog. Iets wat velen van mijn geliefden helaas niet kunnen zeggen.",
          textStyle: { left: "45vw" },
        },
      ],
      nextStepId: "other_choices",
    },
    {
      id: "HASSAN 15",
      type: "sequence",
      sound: HASSAN_FR_SEQ15,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik besluit het opnieuw te proberen. ", delay: 4000 },
        { type: "text", text: "Deze keer breng ik mijn ouders ook op de hoogte. ", delay: 2090 },
        { type: "text", text: "Als dat gebeurt wil ik niet dat het lijkt alsof ik zomaar verdwenen ben. ", delay: 3050 },
        { type: "text", text: "Mijn vader waarschuwt me voor het Griekse eiland Lesbos. ", delay: 4030 },
        { type: "text", text: "Een vriend van hem is daar terechtgekomen en is er nooit meer weggeraakt. ", delay: 3870 },
        { type: "text", text: "Na 2 jaar zonder enig perspectief om erkend te worden als vluchteling is hij gek geworden, ", delay: 4130 },
        { type: "text", text: "in de zee gesprongen en verdronken. ", delay: 4900 },
        { type: "text", text: "Hij drukt me op het hart om niet op het eiland te blijven ", delay: 3080 },
        { type: "text", text: "maar zo snel mogelijk op het vaste land te geraken in Griekenland ", delay: 2890 },
        { type: "text", text: "en daar verder te gaan naar Macedoni\u00eb tot in Servi\u00eb ", delay: 3160 },
        { type: "text", text: "waar hij iemand kent die me kan verder helpen naar Belgi\u00eb, waar de broer van Salim woont.", delay: 3850 },
        { type: "text", text: "Op hoop van zegen.", delay: 5050 },
        { type: "text", text: "", delay: 1970 },
        { type: "goToNext", delay: 1160 },
      ],
      background: {
        src: hassanBG15,
        style: {},
        animations: [{ delay: 50, style: { animationDuration: "47180ms", animationName: "scale20" } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "HASSAN 16",
    },
    {
      id: "HASSAN 16",
      type: "sequence",
      sound: HASSAN_FR_SEQ16,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Het is me gelukt! ", delay: 2190 },
        { type: "text", text: "Toen ik eindelijk in Brussel arriveerde, ", delay: 1960 },
        { type: "text", text: "leek er 100kg van mijn schouders te vallen.", delay: 1970 },
        { type: "text", text: "Het interview bij het commissariaat generaal voor de vluchtelingen en staatlozen was moeilijk. ", delay: 3000 },
        { type: "text", text: "Ik moest wel 10 keer mijn verhaal vertellen tot in de kleinste details. ", delay: 4970 },
        { type: "text", text: "Ik snap wel dat ze willen controleren of ik recht heb op asiel ", delay: 4150 },
        { type: "text", text: "maar door al hun vragen leek het wel alsof ik alles opnieuw moest beleven. ", delay: 3770 },
        { type: "text", text: "Ik zit nu in een opvangcentrum. ", delay: 4130 },
        { type: "text", text: "Al meer dan 6 maanden wacht ik op een beslissende brief.", delay: 2870 },
        { type: "text", text: "", delay: 3130 },
        { type: "goToNext", delay: 1860 },
      ],
      background: {
        src: hassanBG16,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "34000ms", animationName: "scale20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "HASSAN 17",
    },
    {
      id: "HASSAN 17",
      type: "sequence",
      sound: HASSAN_FR_SEQ17,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik heb het moeilijk. ", delay: 5230 },
        { type: "text", text: "Ik kan niets anders doen behalve wachten. Ik snap het niet. ", delay: 1900 },
        { type: "text", text: "Waarom duurt het zo lang? ", delay: 4070 },
        { type: "text", text: "Ik voel dat ik wegglijd. ", delay: 2870 },
        { type: "text", text: "Ik probeer de moed erin te houden maar ik mis mijn familie zo erg. ", delay: 2160 },
        { type: "text", text: "Ik weet dat het raar klinkt. Maar eigenlijk wil ik gewoon terug naar Syri\u00eb. ", delay: 4930 },
        { type: "text", text: "Terug naar mijn land, naar mijn ouders. ", delay: 4080 },
        { type: "text", text: "De oorlog is volgens sommigen bijna ten einde ", delay: 3000 },
        { type: "text", text: "en via een procedure genaamd \u2018vrijwillige terugkeer\u2019 zou ik gewoon mogen teruggaan.", delay: 2760 },
        { type: "text", text: "Misschien moet ik dat gewoon doen?", delay: 5120 },
        { type: "text", text: "", delay: 2990 },
        { type: "goToNext", delay: 1960 },
      ],
      background: {
        src: baseBackgroundImg,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },
      foreground: {
        src: famille,
        style: { height: "50vh", opacity: 0 },
        animations: [
          { delay: 8050, style: { animationName: "opacityNoneTo80", animationDuration: "4090ms" } },
          { delay: 4090, style: { animationName: "opacity80ToFull", animationDuration: "2000ms" } },
          { delay: 3090, style: { animationName: "animationHassanFamille", animationDuration: "20000ms", animationTimingFunction: "ease-in" } },

          // animationHassanFamille
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "info_retour_volontaire",
    },
    {
      id: "choice_retour_volontaire",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Ik weet het even allemaal niet meer. Wat zou jij doen in mijn plaats?<br/>Zou je bli<span class="background-underlined medium">jven wachte</span>n ook al heb je het gevoel dat je langzaam gek wordt en mis je je familie verschrikkelijk? Of zou je proberen terug<span class="background-underlined large">keren naar Syri</span>ë? ',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Blijven wachten",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "HASSAN 18",
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Ja, ik ben<br/>er zeker van',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'HASSAN 18',
          //     },
          //     {
          //       text: 'Ik neem een<br/>andere beslissing',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
        {
          type: "button",
          key: "button-2",
          text: "Teruggaan naar Syrië",
          buttonStyle: choiceButtonStyle,
          action: "fakeChoice",
          actionText:
            "Wanneer ik mijn moeder vertel over mijn plan om terug te keren, vraagt ze of ik mijn verstand verloren heb. Ze vertelt me dat de situatie nog steeds totaal onhoudbaar is. Het is er levensgevaarlijk en voor mij is er geen toekomst daar. Ik zou waarschijnlijk onmiddellijk gearresteerd worden omdat ik aan mijn legerplicht heb verzaakt. Uiteraard heeft ze gelijk. Ik kom snel terug bij mijn verstand, terugkeren zou totaal absurd zijn. Ik ben het mijn familie verschuldigd om het beste van mijn leven hier te maken. Ik ben het Salim verschuldigd. Zijn dood mag niet voor niets zijn.",
          actionTextStyle: { backgroundImage: `url(${blockBlancFakeChoiceLarge})`, maxHeight: "60vh", width: "40vw", maxWidth: "600px" },
        },
      ],
    },
    //30
    {
      id: "HASSAN 18",
      type: "sequence",
      sound: HASSAN_FR_SEQ18,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Op een dag krijg ik de verlossende brief. ", delay: 2190 },
        { type: "text", text: "Ik word erkend als vluchteling en mag blijven! ", delay: 2970 },
        { type: "text", text: "Er stelt zich wel al snel een nieuw probleem. ", delay: 3910 },
        { type: "text", text: "Ik heb maar 2 maanden om een woonst te zoeken.", delay: 2990 },
        { type: "text", text: "Nog een maand, nog een week, nog... Zo zenuwslopend. ", delay: 5080 },
        { type: "text", text: "Het is zo moeilijk want vaak willen huiseigenaars dat je vast werk hebt ", delay: 8890 },
        { type: "text", text: "maar ik spreek amper Nederlands dus ook werk vinden is bijna onmogelijk. ", delay: 3210 },
        { type: "text", text: "Het is een vicieuze cirkel.", delay: 4830 },
        { type: "text", text: "", delay: 2090 },
        { type: "goToNext", delay: 2050 },
      ],
      background: {
        src: hassanBG18,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "HASSAN 19",
    },
    {
      id: "HASSAN 19",
      type: "sequence",
      sound: HASSAN_FR_SEQ19,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Uiteindelijk mag ik een kleine studio gaan bezichtigen in Leuven", delay: 1170 },
        { type: "text", text: "Als ik effectief een kijkje neem zakt de moed me in de schoenen. ", delay: 3900 },
        { type: "text", text: "Het gaat om een kleine kamer zonder raam. ", delay: 4050 },
        { type: "text", text: "Het stinkt er en op de grond zag ik zelfs muizenkeutels. ", delay: 2960 },
        { type: "text", text: "Er is een badkamer op de gang die ik moet delen met 5 anderen.", delay: 4090 },
        { type: "text", text: "Als ik dit teken moet ik minstens een jaar blijven volgens het contract.", delay: 3840 },
        { type: "text", text: "Als ik dit niet teken dan zit ik zonder woonst. ", delay: 4160 },
        {
          type: "text",
          text: "Het is de eerste keer in maanden zoeken dat een eigenaar akkoord gaat om zijn woonst te verhuren aan mij.",
          delay: 3900,
        },
        { type: "text", text: "", delay: 7000 },
        { type: "goToNext", delay: 1080 },
      ],
      background: {
        src: hassanBG19,
        style: { objectPosition: "center 10%" },
        animations: [{ delay: 50, style: { animationDuration: "36150ms", animationName: "scale20" } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "info_appartement",
    },
    {
      id: "choice_appartement",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Wat is nu de beste keuze? Wat zou jij doen?<br/>Het con<span class="background-underlined medium">tract tekenen</span> zodat jij zeker niet op straat moet slapen? Of nog even ve<span class="background-underlined large">rder zoeken</span> en hopen dat jij iets beter vindt? ',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Het contract tekenen",
          buttonStyle: choiceButtonStyle,
          action: "showConfirmation",
          confirmationContent: {
            title:
              'Ben je <span class="background-underlined medium">zeker</span>? <br/>Als ik eraan denk dat ik hier een jaar moet wonen, keert mijn maag bijna om. ',
            buttons: [
              {
                text: "Ja, ik ben<br/>er zeker van",
                buttonStyle: choiceButtonStyle,
                action: "goNext",
                nextStepId: "HASSAN 20",
              },
              {
                text: "Ik neem een<br/>andere beslissing",
                buttonStyle: choiceButtonStyle,
                action: "closeConfirmation",
              },
            ],
          },
        },
        {
          type: "button",
          key: "button-2",
          text: "Nog even verder zoeken ",
          buttonStyle: choiceButtonStyle,
          action: "showConfirmation",
          confirmationContent: {
            title:
              'Ben je <span class="background-underlined medium">zeker</span>? <br/>En wat als ik niets vind? Ik wil echt niet op straat slapen! ',
            buttons: [
              {
                text: "Ja, ik ben<br/>er zeker van",
                buttonStyle: choiceButtonStyle,
                action: "goNext",
                nextStepId: "HASSAN 21",
              },
              {
                text: "Ik neem een<br/>andere beslissing",
                buttonStyle: choiceButtonStyle,
                action: "closeConfirmation",
              },
            ],
          },
        },
      ],
    },
    {
      id: "HASSAN 20",
      type: "sequence",
      sound: HASSAN_FR_SEQ20,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik besluit toch om het contract te tekenen", delay: 2200 },
        { type: "text", text: "Ik wil immers niet het risico lopen om op straat te moeten slapen. ", delay: 2930 },
        { type: "text", text: "Ik probeer mijn kamer wat op te knappen maar dat gaat moeilijk. ", delay: 3920 },
        { type: "text", text: "Er is een groot muizenprobleem en uit de douche komt enkel koud water.", delay: 4070 },
        { type: "text", text: "Ik heb al voor hetere vuren gestaan ", delay: 4900 },
        { type: "text", text: "maar ik verlang zo hard naar een normaal en menswaardig leven.", delay: 2040 },
        { type: "text", text: "", delay: 3980 },
        { type: "goToNext", delay: 1020 },
      ],
      background: {
        src: hassanBG20,
        style: {}, //transition: 'left linear, top linear, width linear, height linear'
        animations: [
          { delay: 50, style: { animationDuration: "25000ms", animationName: "scaleDown20" } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        ],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "HASSAN 22",
    },
    {
      id: "HASSAN 21",
      type: "sequence",
      sound: HASSAN_FR_SEQ21,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik besluit toch nog even verder te zoeken en via de broer van Salim ", delay: 2160 },
        { type: "text", text: "kom ik terecht bij een organisatie die vluchtelingen helpt zoeken naar een woonst. ", delay: 3920 },
        { type: "text", text: "Op een dag word ik door een vrijwilliger opgebeld met de boodschap ", delay: 4920 },
        { type: "text", text: "dat ik onmiddelljk moet langskomen, dat ze denken een goed appartement voor mij te hebben gevonden. ", delay: 4170 },
        { type: "text", text: "Wanneer ik op bezoek ga, wordt het weer wat klaarder in mijn hoofd en hart. ", delay: 3910 },
        { type: "text", text: "Het is geen grote luxe maar het is betaalbaar, proper en goed bereikbaar. Oef.", delay: 3920 },
        { type: "text", text: "", delay: 6160 },
        { type: "goToNext", delay: 1080 },
      ],
      background: {
        src: hassanBG21,
        style: {},
        animations: [{ delay: 50, style: { animationDuration: "30100ms", animationName: "scale20" } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "HASSAN 22",
    },
    //35
    {
      id: "HASSAN 22",
      type: "sequence",
      sound: HASSAN_FR_SEQ22,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Ik woon nu al even in Belgi\u00eb ", delay: 2190 },
        { type: "text", text: "maar eigenlijk ben ik hier niet echt. ", delay: 2810 },
        { type: "text", text: "Ik praat dag en nacht met vrienden en familie die zich ondertussen overal ter wereld bevinden.", delay: 2200 },
        { type: "text", text: "Mijn broer die in het leger zat, is gevlucht naar Libanon. ", delay: 6810 },
        { type: "text", text: "Het huis van mijn neef in het zuiden is volledig kapot door schietgevechten in zijn straat ", delay: 4040 },
        { type: "text", text: "en hijzelf leeft nu in Oostenrijk", delay: 5090 },
        { type: "text", text: "In mijn hoofd en hart leef ik nog steeds in een oorlogsgebied. ", delay: 2980 },
        { type: "text", text: "Het is moeilijk ook om echt mijn zinnen te verzetten.", delay: 3970 },
        { type: "text", text: "Veel mensen ken ik hier niet.. ", delay: 2970 },
        { type: "text", text: "Sommige weken zijn de gesprekken met mijn sociaal assistent het enige menselijke contact dat ik heb.", delay: 3010 },
        { type: "text", text: "Zij zegt me dat ik het even moet proberen loslaten. ", delay: 5080 },
        { type: "text", text: "Een tijd alle contact met mijn Syri\u00eb verbreken. ", delay: 3060 },
        { type: "text", text: "Geen nieuws meer over Syri\u00eb lezen, geen videocalls of whatsappen met mijn familie en vrienden.", delay: 3840 },
        { type: "text", text: "Zal ik dan niet volledig vereenzamen? Of heeft ze misschien gelijk?", delay: 6060 },
        { type: "text", text: "", delay: 4960 },
        { type: "goToNext", delay: 70 },
      ],
      background: {
        src: baseBackgroundImg,
        // style: {}, //transition: 'left linear, top linear, width linear, height linear'
        // animations: [
        //   { delay: 50, style: { animationDuration: '37120ms', animationName: 'scale20' } }, // height: '120%', top: '-10%', width: '120%', left: '-10%'
        // ],
      },
      foreground: {
        src: phoneWhatsapp,
        style: { height: "60vh", opacity: 0 },
        animations: [{ delay: 7000, style: { animationName: "animationHassanWhatsapp", animationDuration: "46190ms" } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "info_added_weird",
    },
    {
      id: "HASSAN 23",
      type: "sequence",
      sound: HASSAN_FR_SEQ23,
      sound_delay: 50,
      sequence: [
        { type: "text", text: "Misschien is het omdat het zomer wordt, ", delay: 3120 },
        { type: "text", text: "misschien omdat ik vannacht voor het eerst in het Nederlands heb gedroomd ", delay: 2930 },
        { type: "text", text: "maar ik begin me weer wat beter te voelen. ", delay: 3040 },
        { type: "text", text: "Het Nederlands begint best goed te lukken.", delay: 2990 },
        { type: "text", text: "Ik durf weer over mijn toekomst na te denken. ", delay: 2160 },
        { type: "text", text: "Ik droom er nog steeds van om bioloog te worden ", delay: 2980 },
        { type: "text", text: "maar mijn sociaal assistent denkt dat het beter is om een kortere opleiding te volgen.", delay: 2920 },
        {
          type: "text",
          text: "Die van laborant lijkt me interessant! Het blijkt niet evident om me in te schrijven aan de hogeschool. ",
          delay: 4920,
        },
        { type: "text", text: "Omdat ik mijn diploma secundair onderwijs niet heb meegenomen uit Syri\u00eb ", delay: 6070 },
        { type: "text", text: "moet ik een hele procedure doorlopen om toch te mogen starten met mijn studie. ", delay: 4000 },
        { type: "text", text: "Ook moet mijn Nederlands nog veel beter worden dan het nu is. ", delay: 4970 },
        { type: "text", text: "Dit neemt allemaal tijd in beslag  ", delay: 3130 },
        { type: "text", text: "en ondertussen verdien ik geen geld.", delay: 2830 },
        { type: "text", text: "Ik wil niet afhankelijk zijn van anderen. ", delay: 2950 },
        { type: "text", text: "Ik twijfel dus. ", delay: 3030 },
        { type: "text", text: "", delay: 1170 },
        { type: "goToNext", delay: 2020 },
      ],
      background: {
        src: hassanBG23,
        style: {},
        animations: [{ delay: 50, style: { animationDuration: "55100ms", animationName: "scale20" } }],
      },
      // textBackgroundColor: '#af8d69',
      nextStepId: "info_final",
    },
    {
      id: "choice_final",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Wat zou jij doen in mijn plaats?<br/>Zou je gaan <span class="background-underlined medium">studeren</span> waardoor je waarschijnlijk nog 4 jaar zonder noemenswaardig inkomen zit? Of zou je een <span class="background-underlined large">job zoeken</span> en de studie laten voor wat het is? ',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Studeren",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "epilogue_fin1",
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Ja, ik ben<br/>er zeker van',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'epilogue_fin1',
          //     },
          //     {
          //       text: 'Ik neem een<br/>andere beslissing',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
        {
          type: "button",
          key: "button-2",
          text: "Werken",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "epilogue_fin2",
          // action: 'showConfirmation',
          // confirmationContent: {
          //   title: '<span class="background-underlined large">Es-tu certain.e&thinsp;?</span>',
          //   buttons: [
          //     {
          //       text: 'Ja, ik ben<br/>er zeker van',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'goNext',
          //       nextStepId: 'epilogue_fin2',
          //     },
          //     {
          //       text: 'Ik neem een<br/>andere beslissing',
          //       buttonStyle: choiceButtonStyle,
          //       action: 'closeConfirmation',
          //     },
          //   ],
          // },
        },
      ],
    },
    {
      id: "epilogue_fin1",

      ...base_epilogue,

      sound: HASSAN_FR_EPILOGFIN1,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: "Dit is hoe mijn leven eruitziet in België",
          text: "Ik besluit het te doen! Ik ga voor een studie laborant en volg op die manier toch nog een beetje mijn droom om bioloog te worden. Het is ontzettend zwaar. Mijn Nederlands is nog lang niet goed genoeg. Ik heb een aantal vrienden op de hogeschool die me helpen maar het blijft moeilijk. Naast mijn studie probeer ik zoveel mogelijk te werken om toch voldoende geld te hebben. Ik ben blij dat ik mijn hart gevolgd heb. Ik droom voortdurend van Syrië. Mijn Syrië. De strijd duurt er voort. Mensen leven er nog steeds in angst voor het dagelijks terreur. Mijn hart bloedt als ik denk aan mijn familie en vrienden die nog steeds daar zijn.",
          textStyle: { left: "45vw" },
        },
      ],
      nextStepId: "outro_syrie",
    },
    {
      id: "epilogue_fin2",

      ...base_epilogue,

      sound: HASSAN_FR_EPILOGFIN2,
      sound_delay: epilogeAnimationTiming + epilogeSoundAdditionalDelay,
      sequence: [
        {
          delay: epilogeAnimationTiming,
          title: "Dit is hoe mijn leven eruitziet in België",
          text: "Het is te riskant. 4 jaar zonder goed inkomen? En als er iets gebeurt met mijn familie in Syrië en mijn ouders plots geld zouden nodig hebben? Ik solliciteer bij een bouwbedrijf in de buurt en word al vlug aangenomen. Het werk is zwaar maar ik verdien tenminste geld. Ik droom van Syrië. Mijn Syrië. De strijd duurt er voort. Mensen leven er nog steeds in angst voor het dagelijks terreur. Mijn hart bloedt als ik denk aan mijn familie en vrienden die nog steeds daar zijn.",
          textStyle: { left: "45vw" },
        },
      ],
      nextStepId: "outro_syrie",
    },
    //40
    {
      ...base_choice_style,
      id: "info1",
      type: "info",

      contentText:
        'Wat zou jij doen in mijn plaats?<br/>Dit grote <span class="background-underlined medium">onrecht</span> aanklagen en de video delen op sociale media of op veilig spelen en <span class="background-underlined large">niets doen</span>?',
      actionText: "Ik informeer me eerst om Hassan te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-watch-1",
          text: "Ik bekijk de getuigenis van Mohamed.",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("kTLW7eG4X54"),
          },
        },
        {
          type: "button",
          key: "button-watch-2",
          text: "Ik bekijk het interview met een expert over vrije meningsuiting in Syrië ",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("Xa0F-N77Q9g"),
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice1",
    },
    {
      ...base_choice_style,
      id: "info2",
      type: "info",

      contentText:
        'Ik twijfel, wat zou jij doen?<br/>Zou je in <span class="background-underlined large">Syrië blijv</span>en en onderduiken bij je neef? Of op zeker spelen en meteen naar <span class="background-underlined large">Turkije vluchten</span>?',
      actionText: "Ik informeer me eerst om Hassan te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-watch-1",
          text: "Ik luister naar de getuigenis van Mohamed over zijn vertrek uit Syrië",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("xxaLKJqBOns"),
          },
        },
        {
          type: "button",
          key: "button-watch-2",
          text: "Ik bekijk de video van UNHCR over intern ontheemde mensen ",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("-QLFE94qTBo"),
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice2",
    },
    {
      ...base_choice_style,
      id: "info4",
      type: "info",

      contentText:
        'Wat een onmogelijk dilemma! Wat zou jij doen in mijn plaats?<br/>Zou je je aanslu<span class="background-underlined very-large">iten bij het regerin</span>gsleger of alles en iedereen achterlaten en vluc<span class="background-underlined large">hten naar Turki</span>je?',
      actionText: "Ik informeer me eerst om Hassan te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-watch-1",
          text: "Ik bekijk het interview met een expert over legerdienst in Syrië",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("q2OKNorKXe8"),
          },
        },
        {
          type: "button",
          key: "button-watch-2",
          text: "Ik bekijk de getuigenis van Mohamed over de reden waarom hij vertrok ",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("yJSyku8BFjc"),
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice4",
    },
    {
      ...base_choice_style,
      id: "info3",
      type: "info",

      contentText:
        'Wat een onmogelijk dilemma! Wat zou jij doen in mijn plaats?<br/>Zou je je aanslu<span class="background-underlined very-large">iten bij het regerin</span>gsleger of alles en iedereen achterlaten en vluc<span class="background-underlined large">hten naar Turki</span>je?',
      actionText: "Ik informeer me eerst om Hassan te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-watch-1",
          text: "Ik bekijk het interview met een expert over legerdienst in Syrië",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("q2OKNorKXe8"),
          },
        },
        {
          type: "button",
          key: "button-watch-2",
          text: "Ik bekijk de getuigenis van Mohamed over de reden waarom hij vertrok ",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("yJSyku8BFjc"),
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice3",
    },
    {
      ...base_choice_style,
      id: "infoEurope",
      type: "info",

      contentText:
        'Ik weet echt niet wat de beste keuze is. Wat zou jij doen mocht je in mijn schoenen staan?<br/>Zou je je leven riskeren en meega<span class="background-underlined very-large">an naar Europa</span>? Of zou je all<span class="background-underlined large">een in Turkije</span> blijven en hopen dat je hier toch een waardig leven kan opbouwen? ',

      actionText: "Ik informeer me eerst om Hassan te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-read-1",
          text: "Ik bekijk het rapport van Amnesty International over pushbacks (mensen die illegaal worden teruggestuurd) in Griekenland",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            backgroundImage: backgoundPurple,
            type: "text",
            title:
              "Amnesty International rapport over : pushbacks en geweld langs Griekse grens<br/><span class='subtitle'>Samenvatting van rapport</span>",
            text: 'Het rapport doet verslag van gesprekken met mensen die pushbacks meemaakten. In totaal zouden naar schatting duizend mensen slachtoffer zijn geworden van deze illegale uitzettingen.<span class="inline-title">DIEPGEWORTELDE PRAKTIJK</span>Het onderzoek focust op de regio rond de Evros-rivier op de grens met Turkije tussen maart en december 2020. Dit nieuwe onderzoek toont aan dat mensenrechtenschendingen inmiddels een diepgewortelde praktijk zijn van de Griekse grensbewaking. <br/>“Het niveau van organisatie dat nodig is om dit op deze schaal uit te voeren, laat zien hoe ver Griekenland gaat om mensen illegaal terug te sturen en dit vervolgens te verdoezelen” zegt migratieonderzoeker Adriana Tidona<span class="inline-title">GESLAGEN EN VERNEDERD</span>De overgrote meerderheid van de mensen was gewelddadig behandeld of had dat bij anderen zien gebeuren door mensen die ze beschreven als Griekse mensen in uniformen maar ook mannen in burgerkleding. Er werd geslagen met stokken of knuppels, getrapt en geduwd, met soms ernstige verwondingen tot gevolg. Mannen werden vaak onderworpen aan vernederende en agressieve naakte fouilleringen, soms in het zicht van vrouwen en kinderen.<span class="inline-title">MARTELING</span>Sommige incidenten kwamen ook neer op marteling, vanwege hun ernst en vernederende of bestraffende bedoeling. Zo doet een Syrische man verslag van hoe \'soldaten\' in het zwart gekleed en met bivakmutsen op zijn groep naar de Evros-rivier terugbracht. Iemand die probeerde te ontsnappen, werd zo meedogenloos hard geslagen dat zijn ruggengraat vermoedelijk werd gebroken: “Hij kon helemaal niet bewegen, hij kon zelfs zijn handen niet bewegen.” Een ander vertelt hoe een man die niet kon zwemmen toch het water in werd gedwongen. De man werd meegesleurd door de stroming en niet meer gezien.<br/><br/>Samenvatting van het verslag van Amnesty International <a href="https://www.amnesty-international.be/sites/default/files/bijlagen/greece-violence_lies_and_pushbacks_2021.pdf" target="_blank">“Greece: Violence, lies, and pushbacks”</a> uit 2021.',
          },
        },
        {
          type: "button",
          key: "button-read-2",
          text: "Ik lees een artikel met getuigenissen over het leven van Syriërs in Turkije ",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            backgroundImage: backgoundPurple,
            type: "text",
            title:
              "Syriërs van Istanboel, een bestaan in ballingschap<br/><span class='subtitle'>MO* magazine (samenvatting van het oorspronkelijk artikel van Arthur Debruyn)</span>",
            text: '<span class="inline-title">Genadeloze Turkse bazen</span>We spreken Housam Mehdin (40), vader van zes kinderen uit Aleppo, Syrië wanneer hij over de middag thuis thee komt drinken en bidden. “Gelukkig heb ik een job in de buurt, zo kan ik even bij mijn vrouw zijn. Maar ik moet maken dat ik geen minuut te laat terug op het werk ben want Turkse bazen zijn genadeloos met Syriërs.” Mehdin herhaalt hetzelfde relaas van uitbuiting op de werkplek dat tal van zijn landgenoten vertellen. Bijna zonder uitzondering krijgen Syriërs tot de helft minder betaald dan hun Turkse collega’s. “De bazen weten dat we koste wat het kost vasthouden aan ons werk, en dat er altijd wel iemand klaarstaat om ons te vervangen”, vervolgt hij. “Ze spelen dat uit, en wij hebben geen andere keuze dan het te pikken. De Turkse overheid kondigt werkvergunningen en een minimumloon voor Syriërs aan, maar de bazen lappen het beleid aan hun laars. “Wanneer de inspectie over de vloer komt, moeten we liegen” zegt Mehdin nog.  Dat is de belangrijkste reden waarom veel gezinnen hun minderjarige kinderen van school halen en aan het werk zetten. Omdat het loon van Syriërs vaak onder het bestaansminimum ligt, moet het hele gezin bijdragen om het te rooien. Ook zo voor de familie Mehdin: toen ze net waren aangekomen, tweeënhalf jaar geleden, ging hun dochter Nuran, net geen twaalf toen, noodgedwongen aan het werk, elke dag snoepjes inpakken.<span class="inline-title">Slapen, werken, eten, herhalen</span>Housam Mehdin mag zich gelukkig prijzen dat hij en zijn gezin het al met al nog weten redden. Veel alleenstaande jonge mannen houden het hoofd maar amper boven water. Overal in Istanboel leven tieners en twintigers, uit onder meer Homs, Aleppo, Idlib en Raqqa, opeengepakt -soms met tientallen anderen- in vochtige, ongezonde kelderappartementen.<br/>Het leven in Turkije? Ploeteren is dat, en daar zijn ze unaniem over. “Slapen, werken, eten en herhalen”, zegt Abdallah Baqir (23) uit Idlib. Hij deelt een kelderruimte samen met zijn broers Sahir (21) en Ali (27) en negentien anderen in Esenler, een buitenwijk van Istanboel. Net als de meeste van zijn kamergenoten werkt Baqir in de aanpalende textielwijk. “We worden allemaal verschrikkelijk onderbetaald”, zegt hij. “We werken als beesten en verdienen maar net genoeg om te overleven en om elke maand honderd dollar opzij te zetten voor de boot naar Europa.” Is het daar dan zo veel beter? “Ja, dat zeggen al onze vrienden die het gehaald hebben, die moeten maar acht uur werken en verdienen een correct loon. Daar hebben we een kans op een eerlijk bestaan. Het leven in Turkije is uitzichtloos. Als we hier niet zo snel mogelijk wegraken, vallen we er nog bij neer.”<span class="inline-title">Uitzichtloze toekomst</span>Naast hem op de bank zit een zestienjarige jongen, alleen in Turkije. Zijn middelbare school in Raqqa is opgedoekt door Islamitische Staat en vervangen door een koranschool, zegt hij. Het zijn allemaal jongens uit doorsnee en zelfs gegoede Syrische families, deserteurs van het regimeleger die willen studeren of een ambacht leren. Uit hun ogen spreekt gelatenheid. Ze werken zes dagen op zeven, minstens twaalf uur per dag. De enige uitweg die ze kennen is het bootje naar één van de Griekse eilanden.<br/><br/>Dit artikel is een samenvatting van extracten van het artikel van MO* Magazine <a href="https://www.mo.be/analyse/syri-rs-van-istanboel-een-bestaan-ballingschap" target="_blank">“Syriërs van Istanboel, een bestaan in ballingschap”</a> gepubliceerd op 24 maart 2016.',
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choiceEurope",
    },
    //45
    {
      ...base_choice_style,
      id: "infoResterFinalementTurquie",
      type: "info",

      contentText:
        'Ik weet het even niet meer. Wat zou jij doen mocht je mij zijn?<br/>Zou je in <span class="background-underlined very-large">Turkije blijven en p</span>roberen hier gelukkig te worden? Of zou je toch prob<span class="background-underlined large">eren naar Europa</span> te gaan?',
      actionText: "Ik informeer me eerst om Hassan te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-read-1",
          text: "Ik lees een fragment uit een rapport van UNHCR over de omstandigheden op de Griekse eilanden ",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonLire,
          iconHover: boutonLireHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            backgroundImage: backgoundPurple,
            type: "text",
            title: "“Ze namen alles mee”",
            text: 'Zemar* was pas 15 toen hij vorige maand uit Afghanistan in opvangcentrum Moria op het Griekse eiland Lesbos aankwam. Hij had een reeks traumatische ervaringen overleefd en was net gescheiden van zijn ouders. Hij had rust nodig.<br/>De eerste nacht werd zijn tas gestolen. Hij voelde zich nog eenzamer. “Ze namen alles mee,” zegt hij. “Ik had niemand om mee te praten.”<br/><br/>Een paar nachten later vielen drie mannen hem aan. Hij wist te ontsnappen en een politiepatrouille bij de hoofdingang van Moria te bereiken. Hij bracht die nacht op de stoep door, veilig, maar niet in staat om de officieren uit te leggen wat er was gebeurd, omdat er geen tolk was.<span class="inline-title">Alleenstaande kinderen</span>De omstandigheden zijn grimmig geworden voor verzoekers om internationale bescherming in opvangcentrum Moria, dat nu 12.800 mensen herbergt – vijf keer zoveel als de capaciteit. Mensen slapen in containers en tenten in een aangrenzende olijfgaard. Bijna 1.000 kinderen, met name tieners, wonen in Moria zonder ouders of familieleden. De helft is ondergebracht in vier beschermde delen, maar de rest slaapt in een tentachtig magazijn, bekend als Rubb Hall, waar ook volwassenen verblijven.<br/>Op de Egeïsche eilanden van Griekenland verblijven meer dan 1.600 alleenstaande minderjarigen in opvangfaciliteiten zoals Moria, die door de overheid worden gerund.<br/><br/>In opvangcentrum Vathy op het eiland Samos slapen meer dan een dozijn alleenstaande meisjes om de beurt in een kleine container, terwijl andere kinderen op containerdaken slapen. Alleenstaande kinderen kunnen maanden in onveilige omstandigheden leven terwijl ze wachten op onderdak. Dit raakt hen mentaal en fysiek.<br/>“We voelen ons allemaal nutteloos… ik heb zoveel stress. Ik verlies mijn geheugen. Elke keer als ik probeer te slapen heb ik nachtmerries. Ik wil alleen mijn familie weer zien,” vertelt Zemar.<br/><br/>Inmiddels zijn er meer dan 4.600 minderjarige verzoekers om internationale bescherming zonder ouders in Griekenland, het hoogste aantal sinds 2016. Slechts één op de vier verblijft in opvangcentra die geschikt zijn voor hun leeftijd, en meer dan 1.000 zijn dakloos of verblijven in tenten.<br/>Zemar vluchtte met zijn gezin vanuit Afghanistan nadat de Taliban zijn oudere broer had vermoord, wegens samenwerking met de Afghaanse autoriteiten. Hij werd gescheiden van zijn ouders op een Turks strand, toen smokkelaars hen en een groep van 50 anderen aan boord van een kleine rubberboot probeerden te krijgen, in het holst van de nacht. Sommigen konden niet snel genoeg naar binnen klimmen en bleven achter.<br/><br/>*Naam gewijzigd wegens veiligheidsredenen.<br/><br/>Fragment van het rapport <a href="https://data2.unhcr.org/en/documents/details/71703#_ga=2.86246424.1887737415.1629278509-1074422688.1629278509" target="_blank">‘Desperate Journeys’</a> gepubliceerd op de website van UNHCR op 15 oktober 2019.',
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choiceResterFinalementTurquie",
    },
    {
      ...base_choice_style,
      id: "info_retour_volontaire",
      type: "info",

      contentText:
        'Ik weet het even allemaal niet meer. Wat zou jij doen in mijn plaats?<br/>Zou je bli<span class="background-underlined medium">jven wachte</span>n ook al heb je het gevoel dat je langzaam gek wordt en mis je je familie verschrikkelijk? Of zou je proberen terug<span class="background-underlined large">keren naar Syri</span>ë? ',
      actionText: "Ik informeer me eerst om Hassan te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-watch-1",
          text: "Ik bekijk het interview met een expert over de huidige situatie in Syrië (situatie begin 2021)",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("V-NpBO6wmmE"),
          },
        },
        {
          type: "button",
          key: "button-watch-2",
          text: "Ik luister naar een expert over moeilijke momenten bij jonge vluchtelingen ",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("g-oVRZs63Fw"),
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice_retour_volontaire",
    },
    {
      ...base_choice_style,
      id: "info_appartement",
      type: "info",

      contentText:
        'Wat is nu de beste keuze? Wat zou jij doen?<br/>Het con<span class="background-underlined medium">tract tekenen</span> zodat jij zeker niet op straat moet slapen? Of nog even ve<span class="background-underlined large">rder zoeken</span> en hopen dat jij iets beter vindt? ',
      actionText: "Ik informeer me eerst om Hassan te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-watch-1",
          text: "Ik luister naar de getuigenis van Mohamed over zijn zoektocht naar een woning",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("6KoH4RKb_x4"),
          },
        },
        {
          type: "button",
          key: "button-watch-2",
          text: "Ik bekijk het interview met een expert over de moeilijke zoektocht naar een woonst",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("Gtk4I_mnPPE"),
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice_appartement",
    },
    {
      ...base_choice_style,
      id: "info_final",
      type: "info",

      contentText:
        'Wat zou jij doen in mijn plaats?<br/>Zou je gaan <span class="background-underlined medium">studeren</span> waardoor je waarschijnlijk nog 4 jaar zonder noemenswaardig inkomen zit? Of zou je een <span class="background-underlined large">job zoeken</span> en de studie laten voor wat het is? ',
      actionText: "Ik informeer me eerst om Hassan te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-ask",
          text: "Ik vraag aan Hassan wat zijn hart zegt ",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonCoeur,
          iconHover: boutonCoeurHoover,
          action: "openDialog",
          dialogContent: {
            type: "image",
            imageSrc: PhylactereHassan,
            imageStyle: {
              marginBottom: "15vh",
              width: "30vw",
              maxWidth: "400px",
              height: "auto",
              maxHeight: "50vh",
              objectFit: "contain",
              objectPosition: "center",
            },
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice_final",
    },
    {
      ...base_choice_style,
      id: "info_added_weird",
      type: "info",

      contentText:
        'Wat zou jij doen in deze situatie?<br/>Zou je het contact met je fa<span class="background-underlined large">milie even verbre</span>ken om je volledig te kunnen focussen op België? Of maak dat alles alle<span class="background-underlined large">en maar moeilij</span>ker? ',

      actionText: "Ik informeer me eerst om Hassan te helpen de juiste beslissing te nemen:",
      actions: [
        {
          type: "button",
          key: "button-watch-1",
          text: "Ik luister naar de getuigenis van Mohamed over zijn lastigste momenten in België",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("LVt3dQgtBVg"),
          },
        },
        {
          type: "button",
          key: "button-watch-2",
          text: "Ik luister naar de getuigenis van een Syrische vluchteling over zijn moeilijkheden hier",
          buttonStyle: { "&:hover": { color: colors.violet } },
          icon: boutonRegarder,
          iconHover: boutonRegarderHoover,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("Yb6lX4-lFmI"),
          },
        },
      ],
      nextButtonStyle: {
        "&:hover": { color: colors.violet },
      },
      nextButtonText: "Neem een beslissing >",
      nextStepId: "choice_added_weird",
    },
    //50
    {
      id: "choice_added_weird",
      type: "choice",

      ...base_choice_style,
      contentText:
        'Wat zou jij doen in deze situatie?<br/>Zou je het contact met je fa<span class="background-underlined large">milie even verbre</span>ken om je volledig te kunnen focussen op België? Of maak dat alles alle<span class="background-underlined large">en maar moeilij</span>ker? ',
      choices: [
        {
          type: "button",
          key: "button-1",
          text: "Contact even verbreken",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "HASSAN 23",
        },

        {
          type: "button",
          key: "button-2",
          text: "Contact behouden",
          buttonStyle: choiceButtonStyle,
          action: "goNext",
          nextStepId: "HASSAN 23",
        },
      ],
    },
    {
      id: "mapIncoherence1",
      type: "map",
      background: baseBackgroundImg,
      mapImage: mapIncoherence1,
      mapImageStyle: { maxWidth: "1500px", width: "80vw", height: "auto" },
      mapContainerClass: "cursor-gray",
      nextStepDelay: 3500,
      nextStepId: "HASSAN 14",
    },
    {
      id: "outro_syrie",
      type: "choice",

      ...base_choice_style,

      fixedImageBackground: baseBackgroundImg,

      fixedImageBackgroundStyle: {
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        zIndex: 0,
      },

      contentStyle: {
        width: "100%",
        maxWidth: 640,
        marginLeft: "auto",
        marginRight: "auto",
        color: "white",
        zIndex: 100,
      },
      contentTextStyle: {
        textTransform: "none",
        textAlign: "center",
      },
      contentText:
        "Het parcours van Hassan speelt zich af tijdens de Syrische burgeroorlog. In december 2024 werd het regime van Bashar al-Assad ten val gebracht. Wil je meer weten over de huidige situatie in Syrië?",

      choices: [
        // {
        //   type: "button",
        //   key: "button-1",
        //   text: "Oui, je regarde la vidéo",
        //   buttonStyle: otherChoiceButtonStyle,
        //   action: "goNext",
        //   nextStepId: "other_choices",
        // },
        {
          type: "button",
          key: "button-1",
          text: "Ja, ik kijk naar de video.",
          buttonStyle: otherChoiceButtonStyle,
          icon: boutonRegarder,
          iconHover: boutonRegarder,
          action: "openDialog",
          dialogContent: {
            transition: "slideUp",
            type: "video",
            videoIframe: getYoutubeIframe("r1QNNoGUa2w"),
          },
        },
        {
          type: "button",
          key: "button-2",
          text: "Nee",
          buttonStyle: otherChoiceButtonStyle,
          action: "goNext",
          nextStepId: "other_choices",
        },
      ],
    },
  ],
};
